import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { isArray } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import ChatHeaderInfo from './ChatHeaderInfo';
import AvtarComponent from '../../../components/AvatarComponent';
import appActions from '../../../appActions';
import axios from "axios";
import storage from '../../../utils/storage';
const configOpiton = window && window.config;

const MessageListPanel = (props) => {
    const dispatch = useDispatch()
    const { messageList, selectedChat, connectionId, handlePing } = props;
    const [selectedListing, setSelectedListing] = useState([]);

    const user = useSelector(state => state.auth.user)

    useEffect(() => {
        if (selectedChat.groupChat) {
            let chatListing = messageList.filter(
                (msg) => msg.msgGroup == selectedChat.chatId,
            );
            setSelectedListing(chatListing);
        } else {
            let listing = messageList.filter(
                (message) =>
                    (message.msgGroup === '' &&
                        message.userId === selectedChat.chatId &&
                        message.sendtoId === connectionId) ||
                    (message.msgGroup === '' && 
                        message.userId === connectionId &&
                        message.sendtoId === selectedChat.chatId) ||
                    (message.msgGroup === selectedChat.chatId),
            );
            if (listing.length < 1) {
               // props.getUserMessage(selectedChat);
            }
            setSelectedListing(listing);
            // dispatch(appActions.USER_GET_ALL_REQUEST({userId: selectedChat.chatId}))
        }
    }, [messageList, selectedChat]);
    return (
        <>
            {selectedChat && selectedChat.chatId && (
                <ChatHeaderInfo selectedChat={selectedChat} userInfo={user} />
            )}
            <div className="chat-messages">
                {/* {selectedListing.map((m, k) => (
                    <MessageItem
                        key={k}
                        item={m}
                        connectionId={connectionId}
                        handlePing={handlePing}
                        selectedChat={selectedChat}
                    />
                ))} */}
                <MessageList messages={selectedListing} connectionId={connectionId}
                        handlePing={handlePing}
                        selectedChat={selectedChat} />
            </div>
        </>
    );
};

const groupMessagesByDate = (messages) => {
    return messages.reduce((acc, message) => {
        const date = moment(message.createdOn).format('YYYY-MM-DD');
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(message);
        return acc;
    }, {});
};

const MessageList = (props) => {
    const { messages } = props
    const groupedMessages = groupMessagesByDate(messages);

    return (
        <div className="message-list">
            {Object.keys(groupedMessages).map((date) => (
                <div key={date} className="message-group">
                    <div className="flex justify-content-center text-sm mb-2" style={{ opacity: 0.7 }}>
                        {moment(date).format('MMMM DD, YYYY')}
                    </div>
                    {groupedMessages[date].map((message) => (
                        <MessageItem
                        key={message.msgUuid}
                        item={message}
                        connectionId={props.connectionId}
                        handlePing={props.handlePing}
                        selectedChat={props.selectedChat}
                    />
                    ))}
                </div>
            ))}
        </div>
    );
};

const MessageItem = (props) => {
    const { connectionId, item, selectedChat } = props;
    const { message, userId, createdOn, attachedFiles, sendtoId } = item;
    const attachmentFile = !isArray(attachedFiles)
        ? JSON.parse(attachedFiles)
        : attachedFiles;
    const getStatusIcon = (item) => {
        const { read, received } = item;
        if (userId !== connectionId) {
            return;
        }
        if (received === 'Y' && read === 'N') {
            return '✔';
        }
        if (received === 'Y' && read === 'Y') {
            return '✔✔'; // You can use two checkmarks to indicate read
        }
        //return '✔'; // Use one checkmark to indicate delivered but not read
    };
    useEffect(() => {
        if (
            item.received === 'N' &&
            item.offsetId &&
            connectionId === sendtoId
        ) {
            props.handlePing(item.offsetId);
        }
    }, [item]);

    const getFileLink = (fileLink) => {
        return `file:///${fileLink}`;
    };

    const handleDownload = async (index) => {
        try {
            const params = {
                filePath: attachmentFile[index].filePath
            }
            const response = await axios.get(`${configOpiton?.END_POINT}/communication/v1/message-exchange/wsmsg/file/download`, {
                headers: {
                    'Authorization': storage.getToken()
                },
                responseType: 'blob', // Important to set responseType
                params
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', attachmentFile[index].fileName); // Set the file name
            document.body.appendChild(link);
            link.click();
            link.remove(); // Clean up the link element
        } catch (error) {
            console.error('Download failed:', error);
        }
    };
    //Todo replace in the AvtarComponent for item.userId with the fullname will be getting from api
    return (
        <div
            className={classNames({
                message: true,
                received: connectionId !== userId,
                sent: connectionId === userId,
            })}
        >
            <AvtarComponent username={item.userId}/>
            <div className="message-content">
                <div className="flex">
                    <div className="message-text">{message}</div>
                    <span
                        className={`ml-2 ${item.read === 'Y' ? 'read' : 'unread'}`}
                    >
                        {getStatusIcon(item)}
                    </span>
                </div>
                {attachmentFile && attachmentFile.length > 0 && (
                    <div>
                        {attachmentFile.map((file, index) => (
                        <div  key={index} className="file-info mt-2">
                            <i
                                className="pi pi-file"
                                style={{ fontSize: '2em', marginRight: '10px' }}
                            ></i>
                            <div className="mt-2">
                                <div></div>
                                <a
                                    href={getFileLink(file.filePath)}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    onClick={() => handleDownload(index)}
                                >
                                    {file.fileName}
                                </a>
                            </div>
                        </div>
                        ))}
                    </div>
                )}

                <div className="message-time">
                    {moment(createdOn).format('h:mm a')}
                </div>
            </div>
        </div>
    );
};

export default MessageListPanel;
